import React, { PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';

type ContentProps = {
  padding?: boolean;
  marginBottom: number;
};

export const Content = ({
  className,
  padding,
  marginBottom,
  ...props
}: React.ComponentProps<'div'> & ContentProps) => {
  return (
    <div
      className={classNames(
        'mt-[30px] mr-0 ml-20 border-[10px] border-[#eef1f0] rounded-[5px] relative',
        className
      )}
      style={{
        marginBottom: `${marginBottom}px`,
        padding: `${padding ? 10 : 0}px`,
      }}
      {...props}
    />
  );
};

type LineProps = {
  visible: boolean;
  marginBottom: number;
};

export const Line = ({
  className,
  visible,
  marginBottom,
  ...props
}: React.ComponentProps<'div'> & LineProps) => {
  return (
    <div
      className={classNames(
        'line-before',
        {
          'line-before-hidden': !visible,
        },
        className
      )}
      style={
        {
          '--margin-bottom-line': `${marginBottom}px`,
        } as React.CSSProperties & { '--margin-bottom-line': string }
      }
      {...props}
    />
  );
};

type Props = {
  name: string;
  desc: string;
  trailing?: boolean;
  padding?: boolean;
  icon: ReactNode;
  marginBottom?: number;
};

const AutomationStep = ({
  name,
  desc,
  trailing = true,
  padding = true,
  icon,
  children,
  marginBottom = 30,
}: PropsWithChildren<Props>) => {
  return (
    <>
      <div className="flex h-12">
        <div className="border-2 border-primary w-12 h-12 rounded-full flex justify-center items-center text-primary">
          {icon}
        </div>
        <div className="ml-2.5">
          <div className="text-primary text-lg leading-[1.1] mb-[7px]">
            {name}
          </div>
          <div className="text-gray-500">{desc}</div>
        </div>
      </div>
      <Content padding={padding} marginBottom={marginBottom}>
        <Line marginBottom={marginBottom} visible={trailing}>
          {children}
        </Line>
      </Content>
    </>
  );
};

export default AutomationStep;
